/**
 * Booth page sets that implement the hub hand-off (auto-start on the member
 * Welcome, `getHomePath` on every exit). Kept in sync by hand with Studio's
 * `lib/projects/hubMembers.ts` and `BRANDING_CHECKLIST.md`. A member outside
 * this list renders as unavailable on the picker instead of stranding a guest
 * on a Welcome that never auto-starts.
 *
 * `null` is the default strip flow (no customPath).
 */
export const HUB_V1_SUPPORTED_CUSTOM_PATHS: ReadonlyArray<string | null> = [null, 'newspaper']

/** Feature flag key, resolved by Studio's registry (`surface: "both"`). */
export const MULTI_PROJECT_HUB_FLAG = 'multi_project_hub'
